var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fabric-detail"},[_c('DetailHead',{attrs:{"data":_vm.rowData}}),_c('DetailMain',{attrs:{"data":_vm.detailData,"loading":_vm.loading}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }